export default "__VITE_ASSET__b81ba69c__"